import type { HEX } from "@/types";

export const CHART_PERCENT_PRECISION = 2;

export const CHART_HISTOGRAM_DEFAULT_COLOR: HEX = "#b7b7b7";

export const CHART_LINE_DEFAULT_COLOR: HEX = "#b7b7b7";

export const CHART_HISTOGRAM_SELECTED_COLOR: HEX = "#999999";
